import React from "react";
import AddButton from "../../../../components/AddButton";
import Modal from "../../../../components/Modal";
import TextInput from "../../../../components/TextInput";
import DeleteButton from "../../../../components/DeleteButton";
import { toast } from "../../../../components/toastNotification";

const CommissionDetailsForm = ({ index, setCommissions, commissions }) => {
  return (
    <div className="bg-LightWhite p-2">
      <div className="grid grid-cols-2 gap-x-2 gap-y-2">
        <div className="">
          <label className="text-xs p-0 sm:text-xxs font-bold text-gray-500">
            Contingency Commission
          </label>
          <div className="lg:w-full">
            <TextInput
              type="number"
              step="0.01"
              min="0"
              max="100.00"
              inputTextHeight="h-6.5"
              placeholder="0"
              value={commissions[index].contingencyCommission}
              onChange={(e) => {
                setCommissions((c) =>
                  c.map((com, i) => {
                    if (i === index) {
                      return {
                        ...com,
                        contingencyCommission: e.target.value,
                      };
                    } else {
                      return { ...com };
                    }
                  })
                );
              }}
            />
          </div>
        </div>
        <div className="">
          <label className="text-xs sm:text-xxs font-bold text-gray-500">
            PIF Min
          </label>
          <div className="lg:w-full">
            <TextInput
              type="number"
              step="0.01"
              min="0"
              max="100.00"
              inputTextHeight="h-6.5"
              placeholder="0"
              value={commissions[index].pifMin}
              onChange={(e) => {
                setCommissions((c) =>
                  c.map((com, i) => {
                    if (i === index) {
                      return {
                        ...com,
                        pifMin: parseInt(e.target.value),
                      };
                    } else {
                      return { ...com };
                    }
                  })
                );
              }}
            />
          </div>
        </div>
        <div className="">
          <label className="text-xs sm:text-xxs font-bold text-gray-500">
            Contingency Commission Transaction
          </label>
          <div className="lg:w-full">
            <TextInput
              type="number"
              step="0.01"
              min="0"
              max="100.00"
              inputTextHeight="h-6.5"
              placeholder="0"
              value={commissions[index].contingencyCommissionTransaction}
              onChange={(e) => {
                setCommissions((c) =>
                  c.map((com, i) => {
                    if (i === index) {
                      return {
                        ...com,
                        contingencyCommissionTransaction: e.target.value,
                      };
                    } else {
                      return { ...com };
                    }
                  })
                );
              }}
            />
          </div>
        </div>
        <div className="">
          <label className="text-xs sm:text-xxs font-bold text-gray-500">
            PIF Max
          </label>
          <TextInput
            type="number"
            step="0.01"
            min="0"
            max="100.00"
            inputTextHeight="h-6.5"
            placeholder="0"
            value={commissions[index].pifMax}
            onChange={(e) => {
              setCommissions((c) =>
                c.map((com, i) => {
                  if (i === index) {
                    return {
                      ...com,
                      pifMax: parseInt(e.target.value),
                    };
                  } else {
                    return { ...com };
                  }
                })
              );
            }}
          />
        </div>
      </div>
      <div className="flex justify-end mt-2 ">
        {" "}
        <DeleteButton
          buttonText="Delete"
          onClick={() => {
            setCommissions((c) => c.filter((item, i) => i !== index));
            toast.fire(
              "Success",
              "Commission Detail was deleted successfully",
              "success"
            );
          }}
        />
      </div>{" "}
    </div>
  );
};

const CommissionDetails = ({ commissions, isShow }) => {
  if (commissions.length === 0) {
    return (
      <div className="flex justify-center text-sm">No Commissions Found</div>
    );
  }
  return (
    <div className="divide divide-y">
      {commissions.map(
        (
          {
            contingencyCommission,
            contingencyCommissionTransaction,
            pifMin,
            pifMax,
          },
          i
        ) => {
          return (
            <div key={i} className="flex flex-row text-xs p-2">
              <div className="grid gap-y-2">
                <div className="grid grid-cols-2 gap-2">
                  <div className="text-gray-700 text-right">
                    Contingency Commission:
                  </div>
                  <div className="font-semibold">
                    {parseFloat(contingencyCommission).toFixed(2)}%
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div className="text-gray-700 text-right">
                    Contingency Commission Transaction:
                  </div>
                  <div className="font-semibold">
                    {parseFloat(contingencyCommissionTransaction).toFixed(2)} %
                  </div>
                </div>
              </div>
              <div className="grid gap-y-2">
                <div className="grid grid-cols-2 gap-2">
                  <div className="text-gray-700 text-right">PIF Min:</div>
                  <div className="font-semibold">
                    {parseFloat(pifMin).toFixed(2)}%
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div className="text-gray-700 text-right">PIF Max:</div>
                  <div className="font-semibold">
                    {parseFloat(pifMax).toFixed(2)}%
                  </div>
                </div>
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};

const AddCommissionDetails = ({
  commissions,
  setCommissions,
  isOpen,
  onClose,
  isShow = false,
  isAdd,
  isEdit,
}) => {
  const GenerateInput = () => {
    setCommissions((c) => [
      ...c,
      {
        contingencyCommission: 0,
        contingencyCommissionTransaction: 0,
        pifMin: 0,
        pifMax: 0,
      },
    ]);
  };

  return (
    <>
      {isEdit || isAdd ? (
        <div className="">
          <div className="grid grid-cols-2">
            <div className="text-primary font-bold font-sans text-sm py-3">
              {"Add Commission Details"}
            </div>
            <div className="py-2">
              <AddButton
                className={"w-1/6 ml-auto"}
                buttonText="New Commission"
                onClick={() => GenerateInput()}
              />
            </div>
          </div>
          <div className="divide-y">
            {commissions.map((c, i) => {
              return (
                <div key={i} className="">
                  <CommissionDetailsForm
                    index={i}
                    setCommissions={setCommissions}
                    commissions={commissions}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <Modal isOpen={isOpen} onClose={onClose} width="fit">
          <div className="text-primary font-bold p-0 border-b border-">
            Commission Details
          </div>
          <hr className="h-1 bg-secondary" />
          <CommissionDetails commissions={commissions} isShow={isShow} />
        </Modal>
      )}
    </>
  );
};

export default AddCommissionDetails;
